import sanitizeHtml from 'sanitize-html';
export const stripTags = (text) => {
    return sanitizeHtml(text, {allowedTags: [], allowedAttributes: {}});
}